import { insurance } from '@axo/shared/data-access/types';
import { IAPI } from '../../lib/models/api';
import {
  createResourceRequest,
  listResourceRequest,
} from '../api-crud.factory';
import { InsuranceEligibilityStatus } from '@axo/shared/data-access/types/insurance';

/**
 * @see https://gitlab.com/a2755/services/insurance/-/blob/main/api/openapi.json
 */

/* @deprecated */
export function getInsurancePersonIsEligibleV2({
  url: { service },
  token,
}: IAPI) {
  return async function getInsurancePersonIsEligible(
    params: insurance.InsurancePersonIsEligibleV2Params
  ) {
    const url = new URL(`/insurance/v2/eligibility`, service);

    const response = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(params),
    });

    const responseJson = await response.json();

    if (!response.ok)
      throw new Error(`Network response was not OK: ${response.status}`);

    return (await responseJson) as insurance.InsurancePersonIsEligibleV2;
  };
}

// TODO
export const createInsuranceEligibility = createResourceRequest<
  insurance.CreateInsuranceEligibilityDto,
  insurance.InsuranceEligibility
>('/insurance/v2/eligibility');

export const listInsuranceEligibilities = listResourceRequest<
  {
    PersonID?: Array<string>;
    LoanApplicationID?: Array<string>;
    Status?: Array<InsuranceEligibilityStatus>;
  },
  insurance.InsuranceEligibility[]
>('/insurance/v2/eligibility');
